"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineValueDisplay = void 0;
var _react = _interopRequireDefault(require("react"));
var _InlineLoader = require("./InlineLoader");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const InlineValueDisplay = _ref => {
  let {
    children,
    loading,
    empty
  } = _ref;
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_InlineLoader.InlineLoader, {
      loaderStyle: _InlineLoader.LoaderStyle.Text
    });
  }
  if (empty) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, InlineValueDisplay.EMPTY);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
exports.InlineValueDisplay = InlineValueDisplay;
InlineValueDisplay.EMPTY = "-";
//# sourceMappingURL=InlineValueDisplay.js.map